import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { hasPrivilege } from './hasPrivilege';
import { useSelector } from 'react-redux';

interface ProtectedLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
  children: React.ReactNode;
  vgroup: string;
  action?: string;
  applicationType?: string;
  className?: string;
}

const ProtectedLink: React.FC<ProtectedLinkProps> = ({ 
  to, 
  children, 
  vgroup, 
  action = 'view', 
  applicationType = 'Admin Transmora',
  className,
  ...rest
}) => {
  const { profile } = useSelector((state: any) => state.auth);
  
  const hasAccess = hasPrivilege(profile, vgroup, action);
  
  if (!hasAccess) {
    return null;
  }

  return (
    <Link to={to} className={className} {...rest}>
      {children}
    </Link>
  );
};

export default ProtectedLink;